import { useState } from "react";
import { getEncryptor, isNetworkError } from "../services/siteService";
import api from "../utils/api";
import { getEmailCode } from "../services/verificationService";
import { codeTypes } from "../utils/lynkco-constants";
import getSiteInfo from "../utils/getSiteInfo";
import { createLeads } from "../services/leadsService";
import { useSelector } from "react-redux";
import { staffInfoSelector } from "../selectors/application";
import { bindCreateAccountConsents } from "../services/userService";
import useAccountLogin from "./useAccountLogin";
import { S_LANG, webStorage } from "../utils/webStorage";

const useCreateAccount = () => {
  /*Redux start*/
  const staffInfo = useSelector(staffInfoSelector);
  /*Redux end*/
  const lang = webStorage.get(S_LANG);
  const [formData, setFormData] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [isNetworkFailed, setIsNetworkFailed] = useState(false);
  const [accountExists, setAccountExists] = useState(false);
  const [phoneExists, setPhoneExists] = useState(false);
  const [sendCodeFailed, setSendCodeFailed] = useState(false);
  const [createAccountFailed, setCreateAccountFailed] = useState(false);
  const [isVerificationStep, setIsVerificationStep] = useState(false);
  const [registrationInProcess, setRegistrationInProcess] = useState(false);
  const [verificationFailed, setVerificationFailed] = useState(false);
  const { login } = useAccountLogin();
  const bind = async (termsContents, newsletterConsent) => {
    return bindCreateAccountConsents({
      email: formData.email,
      countryCode: formData.country.code,
      termsAndConditionNos: termsContents,
      newsletterConsentNo: newsletterConsent,
      wantsNewsletter: formData.subscribed,
      agreedToTerms: formData.agreedToTerms
    });
  };
  const submitAccountInfo = async (evt, data) => {
    setSubmitting(true);
    setIsNetworkFailed(false);
    setAccountExists(false);
    setPhoneExists(false);
    setRegistrationInProcess(false);
    const encryptor = await getEncryptor(data.email);
    const encryptedPassword = encryptor.encrypt(data.password);
    setFormData(data);
    try {
      await api.account.register.check(null, {
        email: data.email,
        mobileCountryCode: data.mobileCountryCode,
        mobileNo: data.mobileNo,
        password: encryptedPassword
      });
    } catch (ex) {
      switch (ex.code) {
        case "USER_CUSTOMER_0008":
          setAccountExists(true);
          break;
        case "USER_CUSTOMER_026":
          setPhoneExists(true);
          break;
        case "USER_CUSTOMER_0031":
          setRegistrationInProcess(true);
          break;
        default:
          setCreateAccountFailed(true);
          break;
      }
      setSubmitting(false);
      return;
    }
    try {
      await getEmailCode(data.email, codeTypes.activeAccount);
      setIsVerificationStep(true);
    } catch (ex) {
      setSendCodeFailed(true);
    }
    setSubmitting(false);
  };
  const onVerification = async (data, termsContents, newsletterConsent) => {
    let contractId;
    try {
      contractId = await bind(termsContents, newsletterConsent);
      const siteInfo = await getSiteInfo();
      const encryptor = await getEncryptor(formData.email);
      const encryptedPassword = encryptor.encrypt(formData.password);
      const body = {
        verify: {
          email: formData.email,
          verificationCode: data.code,
          type: codeTypes.activeAccount
        },
        account: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          countryId: formData.country.code,
          birthday: formData.birthday,
          password: encryptedPassword,
          mobileCountryCode: formData.mobileCountryCode,
          mobileNo: formData.mobileNo,
          contractId: contractId,
          subscribed: formData.subscribed ? "1" : "0",
          dateFormat: siteInfo.dateFormat,
          email: formData.email
        }
      };
      if (staffInfo?.account?.userName) {
        body.account.staff = staffInfo?.account?.userName;
      }
      await api.account.register.byEmail(null, body);
    } catch (ex) {
      console.log("ex", ex);
      if (isNetworkError(ex)) {
        setIsNetworkFailed(true);
      } else {
        switch (ex.code) {
          case "USER_CUSTOMER_0008":
            setAccountExists(true);
            setIsVerificationStep(false);
            break;
          case "USER_CUSTOMER_0011":
            setVerificationFailed(true);
            break;
          case "USER_CUSTOMER_026":
            setPhoneExists(true);
            setIsVerificationStep(false);
            break;
          case "USER_CUSTOMER_0031":
            setRegistrationInProcess(true);
            break;
          default:
            setCreateAccountFailed(true);
            break;
        }
      }
      return {};
    }
    const loginResult = await login(formData.email, formData.password);
    if (formData.subscribed && contractId) {
      await createLeads(lang, formData.email, formData.country.code, contractId);
    }
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    return loginResult;
  };
  return {
    formData,
    submitting,
    isNetworkFailed,
    accountExists,
    phoneExists,
    sendCodeFailed,
    createAccountFailed,
    isVerificationStep,
    registrationInProcess,
    verificationFailed,
    submitAccountInfo,
    onVerification
  };
};
export default useCreateAccount;
